var DesignEnvironment = {
    lstDesignScreen: [],
    draging: "",
    dragId: null,
    schemaDesignId: null,
    tableDesignId: null,
    tableContainerId: null,
    zindex: 0,

    onDragTable: function (id) {
        DesignEnvironment.draging = true;
        DesignEnvironment.dragId = id;
        DesignEnvironment.zindex++;
        document.getElementById(id).style.zIndex = DesignEnvironment.zindex
    },

    onDropTable: function (id) {
        DesignEnvironment.draging = false;
        DesignEnvironment.dragId = null;
        //console.log(DesignEnvironment);
    },

    onMouseMove: function (event) {
        event.preventDefault();
        // console.log(event);
        if (!DesignEnvironment.draging) {
            return;
        }
        var id = DesignEnvironment.dragId;
        //console.log(id);
        if (id != null) {
            console.log("id:" + id);
            var table = document.getElementById(id);
            var schema = document.getElementById(DesignEnvironment.schemaDesignId);
            var rect = schema.getBoundingClientRect();
            var top = event.pageY - (rect.top - schema.scrollTop) - 10;
            var left = event.pageX - (rect.left - schema.scrollLeft) - 10;
            console.log("clienttop:" + schema.clientTop);
            console.log("clientleft:" + schema.clientLeft);
            console.log(top + "-" + left);
            console.log(event.pageX + "-" + event.pageY);
            table.style.top = top;
            table.style.left = left;
        }
    },

    createSelect: function (lstOption) {
        var select = document.createElement("select");
        for (var i = 0; i < lstOption.length; i++) {
            var ob = document.createElement("option");
            ob.innerHTML = lstOption[i].text;
            ob.setAttribute("value", lstOption[i].value);
            select.appendChild(ob);
        }
        return select;
    },

    onSelect: function (e) {
        console.log(e);
        var id = this.getAttribute("designid");
        console.log("id:" + id);
        var ob = DesignEnvironment.findObById(id);
        //
        // deactive old
        //
        console.log(ob.activeItemId + "-" + ob.activeType);
        if (ob.activeItemId != null) {
            var oldActiveItem = document.getElementById(ob.activeItemId);
            console.log(oldActiveItem);
            if (oldActiveItem != null) {
                if (ob.activeType == "table") {
                    oldActiveItem.setAttribute("class", "tableClass");
                } else if (ob.activeType == "line") {
                    oldActiveItem.setAttribute("class", "line");
                }
            }
        }
        //
        // active current item
        //
        var className = this.getAttribute("class");
        if (className.indexOf("line") >= 0) {
            this.setAttribute("class", "line activeItem");
            ob.activeItemId = this.getAttribute("id");
            ob.activeType = "line";
        } else if (className.indexOf("table") >= 0) {
            this.setAttribute("class", "tableClass activeItem");
            ob.activeItemId = this.getAttribute("id");
            ob.activeType = "table";
        }

    },

    onChangeTable: function (obj) {
        var designId = obj.getAttribute("designId");
        var ob = DesignEnvironment.findObById(designId);
        if (ob == null) {
            return;
        }
        console.log(obj);
        console.log(ob);
        var columnIndex = obj.getAttribute("columnIndex");
        var columnTd = document.getElementById(ob.id + "Cols1" + columnIndex);
        columnTd.innerHTML = "";
        var value = obj.value;
        console.log(value);
        if (value == "") {
            //
            // disable all
            //
            var selectC = DesignEnvironment.createSelectByListText([]);
            columnTd.appendChild(selectC);
        } else {
            //
            // enable all & reload column select
            //
            for (var i = 0; i < ob.lstSelectedTable.length; i++) {
                if (ob.lstSelectedTable[i].tableName == value) {
                    var lstOp = [];
                    for (var j = 0; j < ob.lstSelectedTable[i].lstColumn.length; j++) {
                        lstOp.push(ob.lstSelectedTable[i].lstColumn[j].columnName);
                    }
                    var selectC = DesignEnvironment.createSelectByListText(lstOp);
                    columnTd.appendChild(selectC);
                    break;
                }
            }
        }
    },

    createSelectByListText: function (lstOption, defaultValue) {
        var select = document.createElement("select");
        for (var i = 0; i < lstOption.length; i++) {
            var ob = document.createElement("option");
            ob.innerHTML = lstOption[i];
            if (lstOption[i] == defaultValue) {
                ob.setAttribute("selected", true);
            }
            ob.setAttribute("value", lstOption[i]);
            select.appendChild(ob);
        }
        return select;
    },

    clearArray: function (a) {
        while (a.length > 0) {
            a.pop();
        } // Fastest
    },

    addStringToQuery: function (source, addition, seperate) {
        if (source == "") {
            source = addition;
        } else {
            if (seperate == undefined) {
                seperate = ", "
            }
            if (source.indexOf(addition) < 0) {
                source = source + seperate + addition;
            }
        }
        return source;
    },

    buildCriterial: function (columnName, criterial, orCriterial) {
        if (criterial == "") {
            return "";
        } else {
            criterial = criterial.trim();
            var lowerCr = criterial.toLowerCase();
            switch (lowerCr[0]) {
                case '=':
                    break;
                case '>':
                    break;
                case '<':
                    break;
                case 'l':
                    if (lowerCr.indexOf("like") != 0) {
                        criterial = "=" + criterial;
                    }
                    break;
                case 'b':
                    if (lowerCr.indexOf("between") != 0) {
                        criterial = "=" + criterial;
                    }
                    break;
                default:
                    criterial = "=" + criterial;
                    break;
            }
            var result = columnName + " " + criterial;
            if (orCriterial != "") {
                result = "(" + result + " OR " + columnName + " " + orCriterial + ")";
            }
            return result;
        }
    },

    findObById: function (id) {
        for (var i = 0; i < this.lstDesignScreen.length; i++) {
            if (this.lstDesignScreen[i].ob.id == id) {
                return this.lstDesignScreen[i].ob;
            }
        }
        return null;
    },

    design: function (id, lstTable, isView) {
        //
        // clear content
        //
        document.getElementById(id).innerHTML = "";
        //
        // init data
        //
        if(isView == false){

        } else {
            for (var i = 0; i < lstTable.length; i++) {
                if (lstTable[i].lstColumn[0].columnName != '*') {
                    lstTable[i].lstColumn.unshift(
                        {
                            pk: false,
                            columnName: "*",
                            type: "multi"
                        }
                    )
                }
            }
        }
        var obj = {
            id: id,
            lstTable: lstTable,
            lstSelectedTable: [],
            lstSelectedCol: [],
            numberOfColumn: 0,
            activeItemId: null,
            activeType: null,
            lstJoin: [],
            addColumn: function (columnName, tableName) {
                var table = document.getElementById(DesignEnvironment.tableContainerId);
                var rows = table.getElementsByTagName("tr");
                var lstOp = [];
                //
                //  Tao select table
                //
                var cols0 = document.createElement("td");
                for (var i = 0; i < this.lstSelectedTable.length; i++) {
                    lstOp.push(this.lstSelectedTable[i].tableName);
                }
                lstOp.push("");
                var selectT = DesignEnvironment.createSelectByListText(lstOp, tableName);
                selectT.setAttribute("designId", id);
                selectT.setAttribute("columnIndex", this.numberOfColumn);
                selectT.onchange = function () {
                    DesignEnvironment.onChangeTable(this);
                };
                cols0.appendChild(selectT);
                DesignEnvironment.clearArray(lstOp);
                //
                //  Tao select field
                //
                var cols1 = document.createElement("td");
                cols1.setAttribute("style", "width:100px");
                cols1.setAttribute("id", id + "Cols1" + this.numberOfColumn);
                var selectC = document.createElement("select");
                var table = null;
                for (var i = 0; i < this.lstSelectedTable.length; i++) {
                    if (this.lstSelectedTable[i].tableName == tableName) {
                        table = this.lstSelectedTable[i];
                        break;
                    }
                }
                if (table != null) {
                    for (var i = 0; i < table.lstColumn.length; i++) {
                        lstOp.push(table.lstColumn[i].columnName);
                    }
                }
                var select = DesignEnvironment.createSelectByListText(lstOp, columnName);
                cols1.appendChild(select);
                DesignEnvironment.clearArray(lstOp);

                var cols2 = document.createElement("td");
                lstOp = ["WHERE", "GROUP BY", "Max", "Min", "Avg", "Sum", "Count"];
                var selectAction = DesignEnvironment.createSelectByListText(lstOp);
                cols2.appendChild(selectAction);
                DesignEnvironment.clearArray(lstOp);

                var cols3 = document.createElement("td");
                lstOp = ["", "ASC", "DESC"];
                var selectSort = DesignEnvironment.createSelectByListText(lstOp);
                cols3.appendChild(selectSort);
                var cols4 = document.createElement("td");
                var chk = document.createElement("input");
                chk.setAttribute("type", "checkbox");
                chk.setAttribute("value", "1");
                chk.setAttribute("checked", "true");
                cols4.appendChild(chk);
                var cols5 = document.createElement("td");
                var inpCriteria = document.createElement("input");
                inpCriteria.setAttribute("type", "textbox");
                cols5.appendChild(inpCriteria);
                var cols6 = document.createElement("td");
                var inpOrCriteria = document.createElement("input");
                inpOrCriteria.setAttribute("type", "textbox");
                cols6.appendChild(inpOrCriteria);
                rows[0].appendChild(cols0);
                rows[1].appendChild(cols1);
                rows[2].appendChild(cols2);
                rows[3].appendChild(cols3);
                rows[4].appendChild(cols4);
                rows[5].appendChild(cols5);
                rows[6].appendChild(cols6);
                this.numberOfColumn++;
            },

            addTable: function (tableName) {
                var selectedTable = null;
                //
                // check if table is in selected list then do nothing
                //
                //console.log("selected");
                //console.log(this.lstSelectedTable);
                for (var i = 0; i < this.lstSelectedTable.length; i++) {
                    if (this.lstSelectedTable[i].tableName == tableName) {
                        console.log("table exist");
                        return;
                    } else {
                        //console.log("table:" + this.lstSelectedTable[i].tableName);
                    }
                }

                for (var i = 0; i < lstTable.length; i++) {
                    if (lstTable[i].tableName == tableName) {
                        this.lstSelectedTable.push(lstTable[i]);
                        selectedTable = lstTable[i];
                        break;
                    }
                }
                if (selectedTable == null)
                    return;
                var idDesign = id + "Design";
                var div = document.getElementById(idDesign);
                var tableDiv = document.createElement("div");
                tableDiv.setAttribute("class", "tableClass");
                tableDiv.setAttribute("draggable", "true");
                tableDiv.setAttribute("id", tableName);
                tableDiv.setAttribute("designId", id);
                tableDiv.onclick = DesignEnvironment.onSelect;
                div.appendChild(tableDiv);
                var titleDiv = document.createElement("div");
                titleDiv.setAttribute("class", "tableTitle");
                titleDiv.innerHTML = selectedTable.tableName;
                tableDiv.appendChild(titleDiv);
                var columnDiv = document.createElement("div");
                columnDiv.setAttribute("class", "columnsOfTable");
                tableDiv.appendChild(columnDiv);
                tableDiv.style.top = 10+"px";
                //console.log(this.lstSelectedTable.length * 200);
                tableDiv.style.left = this.lstSelectedTable.length * 200 + "px";
                //
                // drag and drop event handle
                //
                /*
                            tableDiv.onmousedown = function (e) {
                                e.preventDefault();
                                DesignEnvironment.onDragTable("table" + selectedTable.name);
                            };
                            tableDiv.onmouseup = function (e) {
                                e.preventDefault();
                                DesignEnvironment.onDropTable("table" + selectedTable.name);
                            };
                */
                //
                // add column on table
                //
                for (i = 0; i < selectedTable.lstColumn.length; i++) {
                    var column = document.createElement("div");
                    column.setAttribute("class", "columnClass");
                    var tableName = selectedTable.tableName;
                    var columnName = selectedTable.lstColumn[i].columnName;
                    column.setAttribute("id", tableName + "." + columnName);
                    column.innerHTML = selectedTable.lstColumn[i].columnName;
                    column.setAttribute("designId", id);
                    column.setAttribute("tableName", tableName);
                    column.setAttribute("columnName", columnName);
                    column.setAttribute("draggable", "true");
                    column.ondblclick = function () {
                        var idDesign = this.getAttribute("designId");
                        for (var i = 0; i < DesignEnvironment.lstDesignScreen.length; i++) {
                            if (DesignEnvironment.lstDesignScreen[i].id == idDesign) {
                                var tableName = this.getAttribute("tableName");
                                var columnName = this.getAttribute("columnName");
                                DesignEnvironment.lstDesignScreen[i].ob.addColumn(columnName, tableName);
                                break;
                            }
                        }
                    };
                    columnDiv.appendChild(column);
                }

                this.updateSelectTable();
                this.zindex++;
            },

            updateJoin: function () {
                var svg = document.getElementById(this.id + "Design");
                var p = svg.getElementsByTagName("p");
                for (var i = 0; i < p.length; i++) {
                    var id = p[i].getAttribute("id");
                    var tables = id.split(".");
                    console.log(tables);
                    var fromTable = tables[0];
                    var fromColumn = tables[1];
                    var toTable = tables[2];
                    var toColumn = tables[3];
                    var select = p[i].getElementsByTagName("select")[0];
                    var selectValue = select.value;
                    var text = p[i].getElementsByTagName("input")[0];
                    var textValue = text.value;
                    this.lstJoin.forEach(function (item) {
                        if (item.fromTable == fromTable && item.fromColumn == fromColumn && item.toTable == toTable && item.toColumn == toColumn) {
                            item.type = selectValue;
                            item.on = textValue;
                        }
                    });
                    console.log(this.lstJoin);

                }
            },

            updateSelectTable: function () {
                var tableDesign = document.getElementById("tableContainer" + this.id);
                var rows = tableDesign.getElementsByTagName("tr");
                var tableCols = rows[0].getElementsByTagName("select");
                var fieldCols = rows[1].getElementsByTagName("select");
                //
                // init table select
                //
                var lstOp = [];
                for (var i = 0; i < this.lstSelectedTable.length; i++) {
                    lstOp.push(this.lstSelectedTable[i].tableName);
                }
                lstOp.push("");
                //
                //  update select
                //
                for (var i = 0; i < fieldCols.length; i++) {
                    var parentT = tableCols[i].parentElement;
                    var parentC = fieldCols[i].parentElement;
                    //var fieldName = fieldCols[i].value;
                    var tableName = tableCols[i].value;
                    var columnIndex = tableCols[i].getAttribute("columnIndex");
                    //
                    //
                    //
                    if (lstOp.includes(tableName)) {
                        var selectT = DesignEnvironment.createSelectByListText(lstOp, tableName);
                        selectT.setAttribute("designId", id);
                        selectT.setAttribute("columnIndex", columnIndex);
                        selectT.onchange = function () {
                            DesignEnvironment.onChangeTable(this);
                        };
                        parentT.removeChild(tableCols[i]);
                        parentT.appendChild(selectT);
                    } else {
                        var selectT = DesignEnvironment.createSelectByListText(lstOp, "");
                        selectT.setAttribute("designId", id);
                        selectT.setAttribute("columnIndex", columnIndex);
                        selectT.onchange = function () {
                            DesignEnvironment.onChangeTable(this);
                        };
                        var selectC = DesignEnvironment.createSelectByListText([], "");
                        parentT.removeChild(tableCols[i]);
                        parentT.appendChild(selectT);
                        parentC.removeChild(fieldCols[i]);
                        parentC.appendChild(selectC);
                    }
                }

            },

            drawJoinLines: function () {
                this.updateJoin();
                //
                // xoa het line cu
                //
                //
                // xoa het line cu
                //
                var svg = document.getElementById(this.id + "Design");
                var p = svg.getElementsByTagName("p");
                for (var i = p.length - 1; i >= 0; i--) {
                    svg.removeChild(p[i]);
                }
                //
                // ve lai line moi
                //
                this.lstJoin.forEach(function (item) {
                    var from = document.getElementById(item.fromTable + "." + item.fromColumn);
                    var to = document.getElementById(item.toTable + "." + item.toColumn);
                    var fromR = from.getBoundingClientRect();
                    var toR = to.getBoundingClientRect();
                    var x1, y1, x2, y2;
                    var id = from.getAttribute("designid");
                    //var svg = document.getElementById(id + "Design");
                    if (fromR.right < toR.right) {
                        x1 = fromR.right;
                        x2 = toR.left;
                        y1 = fromR.top + fromR.height / 2;
                        y2 = toR.top + toR.height / 2;
                    } else {
                        x1 = toR.right;
                        x2 = fromR.left;
                        y1 = toR.top + toR.height / 2;
                        y2 = fromR.top + fromR.height / 2;
                    }
                    //
                    // adjust to position of svg
                    //
                    var svgJQ = $("#" + id + "Design").offset();
                    /*
                                    x1 -= (svg.offsetLeft - svg.scrollLeft - window.scrollX);
                                    x2 -= (svg.offsetLeft - svg.scrollLeft - window.scrollX);
                                    y1 -= (svg.offsetTop - svg.scrollTop - window.scrollY);
                                    y2 -= (svg.offsetTop - svg.scrollTop - window.scrollY);
                    */

                    x1 -= (svgJQ.left - svg.scrollLeft - window.scrollX);
                    x2 -= (svgJQ.left - svg.scrollLeft - window.scrollX);
                    y1 -= (svgJQ.top - svg.scrollTop - window.scrollY);
                    y2 -= (svgJQ.top - svg.scrollTop - window.scrollY);

                    var width = Math.sqrt((y2 - y1) * (y2 - y1) + (x2 - x1) * (x2 - x1));
                    var deg = Math.atan((y2 - y1) / (x2 - x1)) * 180 / Math.PI;
                    var line = document.createElement("p");
                    line.setAttribute("class", "line");
                    line.setAttribute("designid", id);
                    line.setAttribute("id", item.fromTable + "." + item.fromColumn + "." + item.toTable + "." + item.toColumn);
                    var joinOption = ["INNER JOIN", "LEFT JOIN", "RIGHT JOIN", "FULL OUTER JOIN"];
                    var select = DesignEnvironment.createSelectByListText(joinOption, item.type);
                    select.setAttribute("id", item.fromTable + "." + item.fromColumn + "." + item.toTable + "." + item.toColumn + "Select");
                    line.appendChild(select);
                    var text = document.createElement("input");
                    text.setAttribute("id", item.fromTable + "." + item.fromColumn + "." + item.toTable + "." + item.toColumn + "Textbox");
                    text.setAttribute("type", "textbox");
                    text.value = item.on;
                    line.appendChild(text);
                    line.style.left = x1 + "px";
                    line.style.top = y1 + "px";
                    line.style.width = width + "px";
                    line.style.transformOrigin = "top left";
                    line.style.transform = "rotate(" + deg + "deg)";
                    line.onclick = DesignEnvironment.onSelect;
                    svg.appendChild(line);

                });
            },

            generateSQL: function () {
                this.updateJoin();
                var sql = "";
                var column = [];
                var tableDesign = document.getElementById("tableContainer" + this.id);
                var rows = tableDesign.getElementsByTagName("tr");
                var tableCols = rows[0].getElementsByTagName("select");
                var fieldCols = rows[1].getElementsByTagName("select");
                var actionCols = rows[2].getElementsByTagName("select");
                var orderCols = rows[3].getElementsByTagName("select");
                var showCols = rows[4].getElementsByTagName("input");
                var criterialCols = rows[5].getElementsByTagName("input");
                var orCols = rows[6].getElementsByTagName("input");
                console.log(fieldCols);
                for (var i = 0; i < fieldCols.length; i++) {
                    if (fieldCols[i].value == "" || fieldCols[i].value == null) {
                        console.log("cols null");
                        continue;
                    }
                    if (tableCols[i].value == "" || tableCols[i].value == null) {
                        console.log("table null");
                        continue;
                    }
                    var col = {
                        columnName: tableCols[i].value + "." + fieldCols[i].value,
                        tableName: tableCols[i].value,
                        action: actionCols[i].value,
                        order: orderCols[i].value,
                        show: showCols[i].checked,
                        criteria: criterialCols[i].value.trim(),
                        orCriteria: orCols[i].value.trim()
                    };
                    column.push(col);
                }
                console.log(column);
                var select = "";
                var from = "";
                var where = "";
                var groupby = "";
                var having = "";
                var order = "";
                //
                // join process
                //
                console.log("lstJoinT");
                var lstJoinT = [];
                for (var i = 0; i < this.lstJoin.length; i++) {
                    var ob = {
                        fromTable: this.lstJoin[i].fromTable,
                        toTable: this.lstJoin[i].toTable,
                        type: this.lstJoin[i].type,
                        joins: [{
                            fromColumn: this.lstJoin[i].fromColumn,
                            toColumn: this.lstJoin[i].toColumn,
                            on: this.lstJoin[i].on
                        }
                        ]
                    };
                    var bNew = true;
                    for (var j = 0; j < lstJoinT.length; j++) {
                        if (lstJoinT[j].fromTable == ob.fromTable && lstJoinT[j].toTable == ob.toTable && lstJoinT[j].type == ob.type) {
                            lstJoinT[j].joins.push({
                                fromColumn: ob.joins[0].fromColumn,
                                toColumn: ob.joins[0].toColumn,
                                on: this.lstJoin[i].on
                            });
                            bNew = false;
                            break;
                        }
                    }
                    if (bNew) {
                        lstJoinT.push(ob);
                    }
                }
                console.log(lstJoinT);

                for (var i = 0; i < lstJoinT.length; i++) {
                    if (lstJoinT[i] == null) {
                        continue;
                    }
                    var joinTable = [lstJoinT[i].fromTable, lstJoinT[i].toTable];
                    var joinStatement = lstJoinT[i].fromTable + " " + lstJoinT[i].type + " " + lstJoinT[i].toTable + " ON (";
                    var exp = "";
                    for (var j = 0; j < lstJoinT[i].joins.length; j++) {
                        if (exp != "") {
                            exp += " AND ";
                        }
                        exp += "(" + lstJoinT[i].fromTable + "." + lstJoinT[i].joins[j].fromColumn + lstJoinT[i].joins[j].on + lstJoinT[i].toTable + "." + lstJoinT[i].joins[j].toColumn + ")";
                    }
                    joinStatement += exp + " )";
                    from = DesignEnvironment.addStringToQuery(from, joinStatement);
                    for (var j = i + 1; j < lstJoinT.length; j++) {
                        if (lstJoinT[j] == null) {
                            continue;
                        }
                        if (joinTable.indexOf(lstJoinT[j].fromTable) >= 0) {
                            joinTable.push(lstJoinT[j].toTable);
                            joinStatement = lstJoinT[j].type + " " + lstJoinT[j].toTable + " ON (";
                            exp = "";
                            for (var h = 0; h < lstJoinT[j].joins.length; h++) {
                                if (exp != "") {
                                    exp += " AND ";
                                }
                                exp += "(" + lstJoinT[j].fromTable + "." + lstJoinT[j].joins[h].fromColumn + lstJoinT[j].joins[h].on + lstJoinT[j].toTable + "." + lstJoinT[j].joins[h].toColumn + ")";
                            }
                            joinStatement += exp + " )";
                            from = DesignEnvironment.addStringToQuery(from, joinStatement, "\r\n");
                            lstJoinT[j] = null;
                        }
                    }
                }
                for (var i = 0; i < column.length; i++) {
                    switch (column[i].action) {
                        case "WHERE":
                            if (column[i].show) {
                                select = DesignEnvironment.addStringToQuery(select, column[i].columnName);
                                if (column[i].order != "") {
                                    order = DesignEnvironment.addStringToQuery(order, column[i].columnName + " " + column[i].order);
                                }
                            }
                            if (column[i].criteria != "") {
                                if (column[i].criteria[0])
                                    where = DesignEnvironment.addStringToQuery(where, DesignEnvironment.buildCriterial(column[i].columnName, column[i].criteria, column[i].orCriteria), " AND ");
                            }
                            from = DesignEnvironment.addStringToQuery(from, column[i].tableName);

                            break;
                        case "GROUP BY":
                            if (!column[i].show) {
                                sql = "ERROR GROUP BY BUT NOT SHOW";
                            } else {
                                groupby = DesignEnvironment.addStringToQuery(groupby, column[i].columnName);
                                from = DesignEnvironment.addStringToQuery(from, column[i].tableName);
                                if (column[i].order != "") {
                                    order = DesignEnvironment.addStringToQuery(order, column[i].columnName + " " + column[i].order);
                                }
                            }
                            break;
                        default:
                            select = DesignEnvironment.addStringToQuery(select, column[i].action + "(" + column[i].columnName + ")");
                            from = DesignEnvironment.addStringToQuery(from, column[i].tableName);
                            if (column[i].criteria != "") {
                                having = DesignEnvironment.addStringToQuery(having,
                                    DesignEnvironment.buildCriterial(column[i].action + "(" + column[i].columnName + ")", column[i].criteria, column[i].orCriteria),
                                    " AND "
                                );
                            }
                    }
                }
                if (select != "") {
                    select = "SELECT " + select;
                }
                if (from != "") {
                    from = " \r\nFROM " + from;
                }
                if (where != "") {
                    where = " \r\nWHERE " + where;
                }
                if (groupby != "") {
                    groupby = " \r\nGROUP BY " + groupby;
                }
                if (having != "") {
                    having = " \r\nHAVING " + having;
                }
                if (order != "") {
                    order = " \r\nORDER BY " + order;
                }
                sql = select + from + where + groupby + having + order;
                console.log(sql);
                return sql.trim();
            },

            initDesignFromSQL: function (sql) {
                var parser = window.sqlParser;
                try {
                    var sqlObj = parser.parse(sql);
                    var select = sqlObj.value.selectItems;
                    var from = sqlObj.value.from;
                    var where = sqlObj.value.where;
                    var having = sqlObj.value.having;
                    var orderBy = sqlObj.value.orderBy;
                    var groupby = sqlObj.value.groupBy;
                    //
                    // init from table
                    //
                    for (var i = 0; i < from.value.length; i++) {

                    }
                } catch (e) {
                    alert("Can''t parse sql :" + sql);
                }

            }
        };
        var designEl = document.createElement("div");
        DesignEnvironment.schemaDesignId = id + "Design";
        designEl.setAttribute("id", DesignEnvironment.schemaDesignId);
        designEl.setAttribute("class", "viewDesign");
        designEl.setAttribute("width", "1000");
        designEl.setAttribute("height", "600");
        designEl.ondragstart = function (e) {
            console.log("start");
            if (e.target.getAttribute("class").indexOf("tableClass") >= 0) {
                e.stopPropagation();
                e.target.style.zIndex = DesignEnvironment.zindex++;
                DesignEnvironment.draging = "table";
                DesignEnvironment.pageX = e.pageX;
                DesignEnvironment.pageY = e.pageY;
            } else if (e.target.getAttribute("class") == "columnClass") {
                DesignEnvironment.draging = "column";
            }
        };

        designEl.ondragend = function (e) {
            console.log("end");
            if (DesignEnvironment.draging == "table") {
                DesignEnvironment.draging = "";
                console.log(e.target.style.top);
                console.log(e.target.style.left);
                console.log(e.pageY - DesignEnvironment.pageY);
                console.log(e.pageX - DesignEnvironment.pageX);
                var top = parseInt(e.target.style.top);
                var left = parseInt(e.target.style.left);
                e.target.style.top = top + e.pageY - DesignEnvironment.pageY + "px";
                e.target.style.left = left + e.pageX - DesignEnvironment.pageX + "px";
                var designid = e.target.getAttribute("designid");
                var ob = DesignEnvironment.findObById(designid);
                ob.drawJoinLines();
            } else if (DesignEnvironment.draging == "column") {
                console.log("end drag column");
                var fromColumn = e.target.getAttribute("columnname");
                var fromTable = e.target.getAttribute("tablename");
                var toColumn = DesignEnvironment.drop.getAttribute("columnname");
                var toTable = DesignEnvironment.drop.getAttribute("tablename");
                if (toColumn != null && toTable != null) {
                    var join = {
                        "fromColumn": fromColumn,
                        "fromTable": fromTable,
                        "toColumn": toColumn,
                        "toTable": toTable,
                        "type": "INNER JOIN",
                        "on": "="
                    };
                    var designid = e.target.getAttribute("designid");
                    console.log(designid);
                    var ob = DesignEnvironment.findObById(designid);
                    console.log(ob);
                    ob.lstJoin.push(join);
                    ob.drawJoinLines();
                }
                DesignEnvironment.draging = "";
                DesignEnvironment.drop = null;
            }
        };

        designEl.ondragover = function (e) {
            if (DesignEnvironment.draging == "column") {
                DesignEnvironment.drop = e.target;
            }
        };

        document.onkeydown = function (e) {
            console.log(e);
            if (e.keyCode == 46 || e.keyCode == 8) {
                //
                // Xoa
                //
                if (e.target != document.body) {
                    return;
                }
                var ob = DesignEnvironment.lstDesignScreen[0].ob;
                if (ob.activeItemId != null) {
                    var deleteItem = document.getElementById(ob.activeItemId);
                    var id = deleteItem.getAttribute("id");
                    var className = deleteItem.getAttribute("class");
                    deleteItem.parentElement.removeChild(deleteItem);
                    ob.activeItemId = null;
                    ob.activeType = null;
                    //
                    // Xoa data
                    //
                    console.log(className);
                    if (className.indexOf("tableClass") >= 0) {
                        //
                        // delete table
                        //
                        console.log("deleted: " + id);
                        for (var i = 0; i < ob.lstSelectedTable.length; i++) {
                            if (ob.lstSelectedTable[i].tableName == id) {
                                ob.lstSelectedTable.splice(i, 1);
                                break;
                            }
                        }
                        //
                        // delete join of table
                        //
                        for (var i = ob.lstJoin.length - 1; i >= 0; i--) {
                            if (ob.lstJoin[i].fromTable == id || ob.lstJoin[i].toTable == id) {
                                ob.lstJoin.splice(i, 1);
                            }
                        }
                        ob.drawJoinLines();

                        ob.updateSelectTable();

                    } else if (className.indexOf("line") >= 0) {
                        //
                        // delete join only
                        //
                        for (var i = ob.lstJoin.length - 1; i >= 0; i--) {
                            var lineid = ob.lstJoin[i].fromTable + "." + ob.lstJoin[i].fromColumn + "." + ob.lstJoin[i].toTable + "." + ob.lstJoin[i].toColumn;
                            console.log(lineid + "-" + id);
                            if (lineid == id) {
                                ob.lstJoin.splice(i, 1);
                                break;
                            }
                        }
                        ob.drawJoinLines();
                    }

                }

            }
        };

        var tableEl = document.createElement("div");
        DesignEnvironment.tableDesignId = id + "Table";
        tableEl.setAttribute("id", DesignEnvironment.tableDesignId);
        tableEl.setAttribute("class", "tableDesign");

        var table = document.createElement("table");
        DesignEnvironment.tableContainerId = "tableContainer" + id;
        table.setAttribute("id", DesignEnvironment.tableContainerId);
        table.setAttribute("class", "viewTable");
        tableEl.appendChild(table);
        var row0 = document.createElement("tr");
        var row1 = document.createElement("tr");
        var row2 = document.createElement("tr");
        var row3 = document.createElement("tr");
        var row4 = document.createElement("tr");
        var row5 = document.createElement("tr");
        var row6 = document.createElement("tr");
        table.appendChild(row0);
        table.appendChild(row1);
        table.appendChild(row2);
        table.appendChild(row3);
        table.appendChild(row4);
        table.appendChild(row5);
        table.appendChild(row6);

        var cols0 = document.createElement("td");
        cols0.innerHTML = "Table";
        cols0.setAttribute("width", "100px");
        var cols1 = document.createElement("td");
        cols1.innerHTML = "Field";
        var cols2 = document.createElement("td");
        cols2.innerHTML = "Function";
        var cols3 = document.createElement("td");
        cols3.innerHTML = "Sort";
        var cols4 = document.createElement("td");
        cols4.innerHTML = "Show";
        var cols5 = document.createElement("td");
        cols5.innerHTML = "Criteria";
        var cols6 = document.createElement("td");
        cols6.innerHTML = "Or";
        row0.appendChild(cols0);
        row1.appendChild(cols1);
        row2.appendChild(cols2);
        row3.appendChild(cols3);
        row4.appendChild(cols4);
        row5.appendChild(cols5);
        row6.appendChild(cols6);

        document.getElementById(id).appendChild(designEl);
        document.getElementById(id).appendChild(tableEl);
        var badded = false;
        for (var i = 0; i < DesignEnvironment.lstDesignScreen.length; i++) {
            if (DesignEnvironment.lstDesignScreen[i].id == id) {
                badded = true;
                DesignEnvironment.lstDesignScreen[i].ob = obj;
                break;
            }
        }
        if (!badded) {
            DesignEnvironment.lstDesignScreen.push({"id": id, "ob": obj});
        }
        return obj;
    }

};


export default DesignEnvironment;